import { NgxLoggerLevel } from 'ngx-logger';
import { Environment } from './env.model';

export const environment: Environment = {
  production: false,
  apiURL: 'https://dev.geteazi.de',
  logLevel: NgxLoggerLevel.DEBUG,
  keycloak: { url: 'https://dev.geteazi.de/authentication', realm: 'eazi', clientId: 'eazi-portal' },
};
